<template>
  <div class="consumer-terminal">
    <Header />
    <div class="container mx-auto px-4 pt-24 pb-16">
      <h1 class="text-4xl font-bold mb-8 text-center">消费者终端 - 打造智能化生活体验</h1>
      
      <div class="bg-white rounded-lg shadow-lg p-8 mb-8">
        <div class="mb-8">
          <h2 class="text-2xl font-bold mb-4 text-blue-600">智能化终端的引领者</h2>
          <p class="text-gray-700 mb-4">
            chmura云通讯消费者终端业务专注于为用户提供高品质、智能化的终端产品，包括智能手机、平板电脑、智能手表、智能家居设备等。我们的产品融合了前沿技术和时尚设计，为用户打造全方位的智能生活体验。
          </p>
          <p class="text-gray-700 mb-4">
            截至2025年，chmura云通讯消费者终端产品已覆盖全球80多个国家和地区，累计销量突破2亿台。我们的产品在用户满意度、市场份额和品牌影响力等方面均位居行业前列。
          </p>
        </div>

        <div class="mb-8">
          <h2 class="text-2xl font-bold mb-4 text-blue-600">核心产品优势</h2>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div class="bg-blue-50 rounded-lg p-6">
              <h3 class="font-semibold text-lg mb-3">高性能硬件配置</h3>
              <p class="text-gray-700">搭载最新一代处理器、大容量存储和高分辨率显示屏，提供流畅的使用体验。</p>
            </div>
            <div class="bg-blue-50 rounded-lg p-6">
              <h3 class="font-semibold text-lg mb-3">智能化软件系统</h3>
              <p class="text-gray-700">基于AI的智能操作系统，支持语音助手、面部识别、手势控制等功能，提升用户体验。</p>
            </div>
            <div class="bg-blue-50 rounded-lg p-6">
              <h3 class="font-semibold text-lg mb-3">优质摄像系统</h3>
              <p class="text-gray-700">配备多摄像头系统和先进的图像处理算法，支持4K视频录制和夜景拍摄。</p>
            </div>
            <div class="bg-blue-50 rounded-lg p-6">
              <h3 class="font-semibold text-lg mb-3">长续航与快速充电</h3>
              <p class="text-gray-700">大容量电池和快速充电技术，满足用户全天候使用需求。</p>
            </div>
          </div>
        </div>

        <div class="mb-8">
          <h2 class="text-2xl font-bold mb-4 text-blue-600">产品系列与创新</h2>
          <p class="text-gray-700 mb-4">
            chmura云通讯消费者终端产品涵盖多个系列，包括旗舰系列、中端系列和入门系列，满足不同用户的需求。我们的旗舰产品配备了最先进的技术，提供顶级的使用体验；中端产品则在性能和价格之间取得了平衡；入门产品则注重性价比，为用户提供基本的智能化功能。
          </p>
        </div>

        <div class="mb-8">
          <h2 class="text-2xl font-bold mb-4 text-blue-600">用户体验与服务</h2>
          <p class="text-gray-700 mb-4">
            chmura云通讯注重用户体验，通过不断优化产品设计和软件系统，提升用户满意度。我们建立了完善的售后服务体系，提供7×24小时的客服支持和全国范围内的售后网点，为用户提供便捷的维修和退换货服务。
          </p>
          <p class="text-gray-700">
            同时，我们积极收集用户反馈，不断改进产品和服务，确保用户的需求得到满足。我们的用户满意度评分达到4.7/5，高于行业平均水平。
          </p>
        </div>

        <div class="text-center">
          <el-button type="primary" size="large" @click="$router.push('/contact')" class="bg-blue-600 hover:bg-blue-700">
            联系我们了解更多
          </el-button>
        </div>
      </div>
    </div>
    <Footer />
    <BackToTop />
  </div>
</template>

<script>
import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'
import BackToTop from '../components/BackToTop.vue'

export default {
  name: 'ConsumerTerminal',
  components: {
    Header,
    Footer,
    BackToTop
  }
}
</script>

<style scoped>
.consumer-terminal {
  padding-top: 80px;
}
</style>
